import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { DetailDemandNear } from 'src/app/models/Demand'

@Component({
	selector: 'app-details-near-demand',
	templateUrl: './details-near-demand.html'
})
export class DetailsNearDemandComponent implements OnInit, OnDestroy {

	@Input() public nearDemand: DetailDemandNear = new DetailDemandNear()
	@Input() public parentDemandAlreadyChild: boolean = false
	@Input() public parentDemandAlreadyScheduled: boolean = false
	@Output() public agroupNearDemand = new EventEmitter()
	@Output() public close = new EventEmitter()

	public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public modalConfirmEnable: boolean = false
	public openModalViewInform: boolean = false
	public messageModaInform: string = ''
	public carouselPageNow: number = 1
	public carouselPages: number = 0
	public mediaUrlSelected: string = ''

	public ngOnInit(): void {
		this.carouselPages = Math.ceil(this.nearDemand.media.length / 3)
	}

	public agroupInDemand() {
		this.agroupNearDemand.emit()
	}

	public closeNearDetails() {
		this.close.emit()
		removeToolTip()
	}

	public moveCarousel(direction: 'left' | 'right') {
		const carousel = document.getElementById('near-carousel-content') as HTMLDivElement
		const carouselWidth: number = 748

		if (direction == 'left') {
			if (this.carouselPageNow > 1) {
				this.carouselPageNow--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNow < this.carouselPages) {
				this.carouselPageNow++
			}
		}

		if (this.carouselPageNow > 1) {
			this.arrowLeftEnable = true
		} else {
			this.arrowLeftEnable = false
		}

		if (this.carouselPageNow == this.carouselPages) {
			this.arrowRightEnable = false
		} else {
			this.arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public openClosePhotoFromCarousel(media?: string) {
		if (media) {
			this.photoFromCarouselEnable = true
			this.mediaUrlSelected = media
		} else {
			this.photoFromCarouselEnable = false
			removeToolTip()
		}
	}

	public openCloseModalConfirm() {

		if (this.parentDemandAlreadyChild) {
			this.openCloseModalViewInform('alreadyChilds')
			return
		} else if (
			this.parentDemandAlreadyScheduled &&
			['PENDENTE', 'ATRASADO'].includes(this.nearDemand.status)
		) {
			this.openCloseModalViewInform('bothScheduled')
			return
		}

		this.modalConfirmEnable = !this.modalConfirmEnable
		removeToolTip()
	}

	public openCloseModalViewInform(
		mode?: 'bothScheduled' | 'alreadyChilds'
	) {
		if (!mode) {
			this.openModalViewInform = false
			this.messageModaInform = ''
			return
		} else if (mode == 'alreadyChilds') {
			this.messageModaInform =
				'Não é possivel realizar o agrupamento pois existem outras solicitações agrupadas na solicitação atual!'
		} else if (mode == 'bothScheduled') {
			this.messageModaInform =
				'Não é possível realizar o agrupamento pois as duas solicitações já possuem agendamento!'
		}

		this.openModalViewInform = true
	}

	public ngOnDestroy(): void {
		document.body.style.overflow = 'auto'
	}
}
